import styled from "styled-components";
import { Wrapper } from "AppReact";

export default Wrapper(
  styled.div`
    margin-right: 18px;
  `
);
